import { ClientAttributes } from "./getClientAttributes";

/** The target's line height */
export const LINE_HEIGHT = 1.5;

type GetTargetHeightType = Pick<
  ClientAttributes,
  "lineCount" | "showCompleteTranscript" | "transcriptContainerHeight"
> & { fontSize: number };

export function getTargetHeight({
  fontSize,
  lineCount,
  showCompleteTranscript,
  transcriptContainerHeight,
}: GetTargetHeightType) {
  // If the line count is set, then use it to determine the height of the target
  if (lineCount) return `${fontSize * LINE_HEIGHT * lineCount}px`;

  // If the container height is set, then use it to determine the height of the target
  // Note: the container height is deprecated and we're discouraging its use as a param
  // in favor of the line count
  if (transcriptContainerHeight && transcriptContainerHeight !== 0)
    return `${transcriptContainerHeight}px`;

  // If the line count is not set and the complete transcript is NOT being displayed,
  // then show 2 lines by default
  if (!showCompleteTranscript) return `${fontSize * LINE_HEIGHT * 2}px`;

  // If the line count and the transcript container height are not set AND the
  // complete transcript is being displayed, then use the height based off the viewport
  // set in the CSS
  return undefined;
}
